var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEditOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6566 26L15.9998 26L15.9998 23M15.1024 23.8974L26.4107 12.589C27.1918 11.808 28.4581 11.808 29.2392 12.589C30.0202 13.3701 30.0202 14.6364 29.2392 15.4174L17.764 26.8926C17.2279 27.4287 16.9599 27.6967 16.6632 27.9271C16.3996 28.1318 16.1195 28.3142 15.8256 28.4723C15.4948 28.6503 15.1411 28.7868 14.4339 29.0599L12 29.9998L12.7831 27.6501C13.0504 26.8483 13.184 26.4473 13.3699 26.0729C13.535 25.7404 13.7305 25.424 13.9541 25.1276C14.2058 24.7939 14.5047 24.4951 15.1024 23.8974Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditOrder);
export default __webpack_public_path__ + "static/media/icon_edit_order.ab83c9f7b08f9c27c6627799ab767fd7.svg";
export { ForwardRef as ReactComponent };